(() => {
  if (customElements.get('tf-you-pick-gallery')) return;
  class TFYouPickGallery extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.root = document.getElementById(this.dataset.rootId);
      if (!this.root || !this.root.contains(this)) return;
      if (this.root.querySelector('tf-you-pick-gallery') !== this) return;
      this.events = new AbortController();
      this.badge = this.querySelector('template').content.firstElementChild.cloneNode(true);
      this.badge.hidden = true;
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      };
      const signal = this.events.signal;
      this.root.addEventListener('change', () => { this.hide(); this.schedule(); }, {capture: true, signal});
      this.root.addEventListener('click', (event) => {
        if (event.target.closest('variant-swatch-king, variant-radios, variant-selects')) this.hide();
        this.schedule();
      }, {capture: true, signal});
      this.root.addEventListener('load', this.schedule, {capture: true, signal});
      this.root.addEventListener('error', () => { this.hide(); this.schedule(); }, {capture: true, signal});
      this.root.addEventListener('scroll', this.schedule, {capture: true, passive: true, signal});
      this.root.addEventListener('slideChanged', this.schedule, {signal});
      window.addEventListener('resize', this.schedule, {passive: true, signal});
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.ownMutation(record))) this.schedule();
      });
      this.observer.observe(this.root, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['class', 'aria-checked', 'aria-current', 'hidden', 'src', 'srcset', 'data-media-id', 'value']
      });
      this.sync();
    }
    ownMutation(record) {
      if (record.target === this.badge || this.badge.contains(record.target)) return true;
      if (record.type === 'childList') return [...record.addedNodes, ...record.removedNodes].every(node => node === this.badge);
      return false;
    }
    visibleInViewer(slide, viewer) {
      if (slide.hidden || !slide.getClientRects().length || getComputedStyle(slide).visibility === 'hidden') return false;
      const box = slide.getBoundingClientRect();
      const view = viewer.getBoundingClientRect();
      const overlap = Math.max(0, Math.min(box.right, view.right) - Math.max(box.left, view.left));
      return box.width > 0 && view.width > 0 && overlap / Math.min(box.width, view.width) >= 0.85;
    }
    sync() {
      if (!this.isConnected || !this.events) return;
      // Media rebuilds can clone an existing overlay. Keep only this controller's badge.
      this.root.querySelectorAll('.tf-yp-color-badge').forEach(badge => {
        if (badge === this.badge) return;
        const parent = badge.parentElement;
        badge.remove();
        if (!parent.querySelector('.tf-yp-color-badge')) parent.classList.remove('tf-yp-image-frame');
      });
      const gallery = document.getElementById(this.dataset.galleryId);
      if (!gallery || !this.root.contains(gallery)) return this.hide();
      if (this.gallery !== gallery) {
        this.gallery = gallery;
        gallery.addEventListener('tf:variant-media-ready', this.schedule, {signal: this.events.signal});
      }
      const viewer = gallery.querySelector('.product__media-list');
      if (!viewer) return this.hide();
      const slides = Array.from(viewer.children).filter(slide => this.visibleInViewer(slide, viewer));
      const slide = slides.find(item => item.classList.contains('is-active')) || slides[0];
      const frame = slide?.querySelector('.product__modal-opener--image .product__media.media');
      const img = frame?.querySelector('img');
      if (!img || !img.complete || !img.naturalWidth) return this.hide();
      if (this.badge.parentElement !== frame) {
        this.badge.parentElement?.classList.remove('tf-yp-image-frame');
        frame.classList.add('tf-yp-image-frame');
        frame.append(this.badge);
      }
      this.badge.hidden = false;
    }
    hide() {
      if (this.badge && !this.badge.hidden) this.badge.hidden = true;
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.badge?.parentElement?.classList.remove('tf-yp-image-frame');
      this.badge?.remove();
      this.events = null;
    }
  }
  customElements.define('tf-you-pick-gallery', TFYouPickGallery);
})();
